<template>
    <div v-bind:class="{'show-activities-filter-container': showHiddenFilter}" class="hidden-filter-part">
        <div class="md-header hd-24 bold black"><span class="word-container">{{$t('web.filter-container.header')}}</span><i @click="showHiddenFilter = false" class="far fa-times"></i></div>
        <div class="filter">
            <div class="provider-filter filter-column">
                <div class="filter-title hd-18 shuttle-gray bold">{{ $t('web.filter-container.provider') }}</div>
                <div class="provider">
                    <label v-for="provider in providers" class="checkbox">
                        <input v-model="checkedProvider" :value="provider" type="checkbox">
                      <template v-if="provider === 'trip'">{{ $t('web.travel-activities.provider-'+ "hk." + provider + ".com")}}</template>
                      <template v-else>{{ $t('web.travel-activities.provider-'+ provider) }}</template>
                    </label>
                </div>

            </div>
            <div class="price-filter filter-column">
                <div class="filter-title hd-18 shuttle-gray bold">{{$t('web.filter-container.price')}}</div>
                <div class="slider-container">
                    <div class="price-range">
                        <div class="min-price"> {{currency_prefix}}{{(price[0]/currency_exchange_rate).toFixed(0)}} </div>
                        <div>-</div>
                        <div class="max-price"> {{currency_prefix}}{{(price[1]/currency_exchange_rate).toFixed(0)}}</div>
                        <div v-if="price[1] === max_price">+</div>
                    </div>
                    <vue-slider class="vue-slider" v-model="price" :dotStyle="{ height:'20px', width:'20px' }" :min="min_price" :max="max_price" :tooltip="'none'" :tooltip-formatter="formatter" ></vue-slider>
                </div>
<!--                <input class="slider is-fullwidth" step="1" min="0" max="100" value="50" type="range">-->

            </div>
            <div class="category-filter filter-column">
                <div class="filter-title hd-18 shuttle-gray bold">{{$t('web.filter-container.category')}}</div>
                <div class="category">
                    <label v-for="category in activities_categories" class="checkbox">
                        <input v-model="checkedCategory" :value="category.id" type="checkbox">
                        {{category.name}} ({{category.count}})
                    </label>
                </div>
            </div>
        </div>
        <div class="filter-confirm-button-container">
            <div @click="clearAllFilter" class="clear-all-button hd-16 gray400">
                <a class="gray400">{{$t('web.filter-container.clear-all')}}</a>
            </div>
            <div @click="filter" class="filter-confirm-button hd-16 white">
                <a class="white">{{$t('web.filter-container.filter')}}</a>
            </div>
        </div>
    </div>

</template>

<script>
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/antd.css'

    const maxPrice = 5000;
    const minPrice = 0;

    export default {
        props: {
            providers: Array,
            currency_prefix: String,
            currency_exchange_rate: Number,
            showHiddenFilter: Boolean,
            activities_categories: Array,
            search_keyword: String,
        },

        data(){
            return {
                max_price: maxPrice,
                min_price: minPrice,
                price: [minPrice, maxPrice],
                formatter: v => `$${('' + v).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
                checkedProvider: [],
                checkedCategory: [],
            }
        },

        components: {
            VueSlider
        },

        methods: {
            toggle(){
                // $("body").toggleClass('show-activities-filter-container');
                this.showHiddenFilter = !this.showHiddenFilter;
            },
            clearAllFilter(){
                this.checkedProvider = [];
                this.checkedCategory = [];
                this.price = [this.min_price, this.max_price];
            },
            filter(){
                const url = new URL(window.location.href);
                const paramString = new URLSearchParams();

                if (this.search_keyword !== ''){
                    paramString.append('q',this.search_keyword);
                }
                if (this.checkedProvider.length > 0) {
                    paramString.append('provider', this.checkedProvider);
                }
                if (this.checkedCategory.length > 0){
                    paramString.append('categories',this.checkedCategory);
                }
                if (this.price[0] > this.min_price || this.price[1] < this.max_price){

                    if (this.price[1] === this.max_price){
                        this.price[1] = null;
                    }

                    paramString.append('price', [this.price[0], this.price[1]]);
                }
                window.location.href = url + '?' + paramString.toString();


            }
        },

        mounted() {
            this.$events.$on('travel-activities-filter-container:toggle', ()=>{
                this.toggle();
            });
            const query = window.location.search;
            const paramString = new URLSearchParams(query);
            paramString.forEach( (value, key) => {
                if (key === 'filterprovider'){
                    this.checkedProvider = value.split(',');
                }
                if (key === 'price'){
                    const price = value.split(',');
                    if (price[1] === ''){
                        this.$set(this.price, 1, maxPrice);
                        this.$set(this.price, 0, parseInt(price[0]));
                    } else {
                        this.$set(this.price, 1, parseInt(price[1]));
                        this.$set(this.price, 0, parseInt(price[0]));
                    }
                }
                if (key === 'categories'){
                    this.checkedCategory = value.split(',');
                }
            });
        }

    }
</script>

<style scoped lang="scss">
    @import "../../sass/_mixin.scss";
    .hidden-filter-part {
        background: #FFFFFF;
        display: none;
        margin-bottom: 32px;
        position: relative;
        @include responsive(){
            margin: unset;
            position: fixed;
            top: 0;
            left: 0;
            height: 100%;
            z-index: 2147483647;
            width: 100%;
            overflow: auto;
        }

        .md-header{
            @include responsive(){
                display: block;
                text-align: center;
                padding-top: 24px;
            }
            .word-container{
                display: none;
                @include responsive(){
                    display: block;
                }
            }
            .far{
                position: absolute;
                right: 16px;
                top: 16px;

                @include responsive(){
                    top: 30px;
                    right: 24px;
                }
            }
        }

        .filter {
            display: flex;
            justify-content: space-between;
            @include responsive(){
                display: block;
                margin-top: unset;
            }

            .filter-column {
                width: 100%;
                padding: 40px 24px 24px 24px;
                @include responsive(){
                    padding: 24px;
                }

                .filter-title {
                    margin-bottom: 12px;
                }

                .provider,
                .category {
                    display: flex;
                    flex-wrap: wrap;

                    .checkbox {
                        width: 50%;
                        margin-bottom: 8px;
                    }
                }
            }

            .price-filter{
                .price-range{
                    display: flex;
                    margin-bottom: 8px;
                }
                .slider-container{
                    @include responsive() {
                        padding: 0 24px;
                    }
                }
            }
        }
        .filter-confirm-button-container{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding: 16px;
            .filter-confirm-button{
                background: #59D876;
                border-radius: 4px;
                padding: 6px 32px;
            }
            .clear-all-button{
                margin-right: 16px;
            }
        }
    }

    .show-activities-filter-container{
        display: block !important;
    }

</style>
<style lang="scss">
    .vue-slider{
        .vue-slider-dot{
            width: 20px !important;
            height: 20px !important;
        }
    }
</style>
